/**
 * **전대 세계 비석** (TOMB-R1).
 *
 * > 사용자: *"전대 세계의 흔적을 재미있는 통계 수치를 더해서 볼수 있게 하자.
 * > 지난 세계 1등 동상 비석 좋아. (다만 전대 세계가 너무 많아지면 난잡해지니까
 * > 비석을 누르면 게시판처럼 내용만 보이게 하자. 몇번째 세계를 건너왔는지도 표현하면)"*
 *
 * ⚠ **통계 검사 항목 이름을 손으로 안 적는다.** 서버 `EPITAPH_STATS` 미러에서 도출한다 —
 * 검사 항목이 늘면 스키마 컬럼 하나로 여기 표기가 저절로 따라온다(check-mirror 부류).
 * 지난 세계는 리셋 순간 종결 스냅샷이라, 이 세계부터 쌓인다(과거 소급 불가).
 */
import { S, esc } from '../../core/state.js';
import { muted, num, npcHead } from './common.js';
import { EPITAPH_STATS } from '../../world/map.js';
import { levelLabel } from '../../core/level-label.js';
import { starMark } from '../star.js';

function ago(sec0) {
  const d = Math.max(0, Math.floor((Date.now() / 1000 - sec0) / 86400));
  return d <= 0 ? '오늘' : `${d}일 전`;
}

export function render() {
  const y = S.you;
  const seen = y && Number.isFinite(y.worldsSeen) ? y.worldsSeen : 0;

  let h = npcHead() + '<section class="ux-hero"><span class="ux-kicker">전대 세계의 비석</span><h3 class="ux-title">이곳에 남은 흔적</h3>'
    + '<p class="ux-summary">돌아볼 세계를 펼쳐 전투력 1~3위와 함께 쌓인 기록을 읽는다.</p>'
    + (seen > 0 ? `<p class="qt">내 세계 참여 ${num(seen)}회</p>` : '') + '</section>';

  if (!S.epitaphs) {
    return h + muted(S.loadErr ? S.loadErr + ' — 다시 열면 재시도한다.' : '불러오는 중…');
  }
  if (!S.epitaphs.length) {
    return h + muted('아직 종료된 세계가 없다. <b>현재 세계가 끝나면</b> 기록을 확인할 수 있다.');
  }

  h += S.epitaphs.map((e) => {
    const leaders = Array.isArray(e.leaders) ? e.leaders.slice(0, 3)
      : e.champion_name ? [{ name: e.champion_name, level: e.champion_level, power: e.champion_power }] : [];
    const ranking = leaders.length ? leaders.map((p, i) => `<div class="tombchamp"><b>${i + 1}위 ${starMark(p.name)}${esc(p.name)}</b>`
      + ` <span class="qt">Lv.${levelLabel(p.level)} · 전투력 ${num(p.power)}</span></div>`).join('')
      : '<div class="tombchamp qt">순위 기록 없음</div>';
    const legacy = leaders.length && e.leadersRecorded !== true ? '<div class="qt">이 세계는 1위 기록만 남아 있다.</div>' : '';
    // 통계는 미러 목록에서 도출 — 값이 있는(0 초과) 검사 항목만 보여준다
    const stats = EPITAPH_STATS
      .map((s) => [s.ko, e[s.key]])
      .filter(([, v]) => Number(v) > 0)
      .map(([ko, v]) => `<span class="qt">${ko} <b>${num(v)}</b></span>`)
      .join(' · ');
    // Older servers sent a login token in this field; only the new public response resolves a name.
    const lotto = typeof e.leadersRecorded === 'boolean' && e.lottery_top
      ? `<div class="qt">복권 당첨 · ${esc(e.lottery_top)}</div>` : '';
    return `<details class="tombrow ux-details" name="tomb-world" id="tomb-world-${Math.floor(Number(e.world_n) || 0)}"><summary class="tombhead"><b>제 ${num(e.world_n)} 세계</b>`
      + `<span class="qt">${ago(e.ended_at)} · 기록 펼치기</span></summary>`
      + ranking + legacy
      + (stats ? `<div class="tombstats">${stats}</div>` : '')
      + lotto
      + '</details>';
  }).join('');

  return h + '<div class="ux-actions"><button onclick="act.openPanel(\'hall\')">세계별 명예의 전당 고르기</button><button class="ghost" onclick="act.openPanel(\'worldlife\')">현재 세계와 내 여정으로</button></div>';
}
